import axios from 'axios';

import { API_ROUTE } from '@/constants/apiRoutes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
const nouvelleOperationEndpoint = API_ROUTE.NOUVELLE_OPERATION;

interface GestionPilotee {
  codeSupport: string;
  profil: string;
  libelleSupport: string;
  gestionnaire: string;
  srri: number;
  type: string;
}

export const getGestionPiloteeDetail = async (GP: GestionPilotee) => {
  const versementData = JSON.parse(sessionStorage.parcoursVersementData);
  const response = await axios.post(
    `${apiBaseUrl}${nouvelleOperationEndpoint}`,
    {
      gp: GP.codeSupport,
      libelleSupport: GP.libelleSupport,
      gestionnaire: GP.gestionnaire,
    },
    {
      headers: {
        token: `${versementData.token}`,
      },
    }
  );

  if (!response) {
    throw new Error('Erreur lors de la recuperation des gestions pilotees');
  }
  const data = await response.data;
  return data;
};
